if (!customElements.get('suggested-searchterm')) {
customElements.define('suggested-searchterm', class SuggestedSearchTerm extends HTMLElement {
  constructor() {
    super();
}

connectedCallback() {
this.searchTerm = this.dataset.searchterm || this.innerText;
this.predictiveSearch = this.closest('predictive-search');
this.addEventListener('click', this.onSuggestedSearchTermClick.bind(this));
// Sicherstellen, dass das neue Element den Fokus korrekt behandelt
this.addEventListener('mousedown', (event) => {
  event.preventDefault(); // Verhindert einen ungewollten Blur auf das Parent-Element
});
}


removeEmojis(text) {
  // Allgemeine Regex für Emojis
  return text.replace(/[\p{Emoji_Presentation}\p{Emoji}\uFE0F]/gu, '').trim();
}

onSuggestedSearchTermClick() {
  this.predictiveSearch.input.value = this.removeEmojis(this.searchTerm);
  this.predictiveSearch.input.dispatchEvent(new Event('input'));
}
});
}